export const interactions = {
  'with-clickable': {
    cursor: 'pointer',
    _hover: {
      cursor: 'pointer',
    }
  },
  'with-clickable-text': {
    cursor: 'pointer',
    color: 'inherit',
    transition: '0.2s color ease',
    _hover: {
      cursor: 'pointer',
      color: 'brand.500',
    }
  },
  'with-listing-item': {
    backgroundColor: 'white',
    boxShadow: "1px 2px 6px rgba(0,0,0,0.10)",
    border: "1px solid",
    borderColor: "transparent",
    transition: "0.2s all ease",
    bgColor: "white",
    cursor: 'pointer',
    _hover: {
      cursor: 'pointer',
      borderColor: "brand.500",
      bgColor: "brand.50",
    }
  },
  'with-listing-item-editing': {
    backgroundColor: 'red',
    boxShadow: "1px 2px 6px rgba(0,0,0,0.10)",
    border: "1px dashed",
    borderColor: "brand.500",
    transition: "0.2s all ease",
    bgColor: "white",
    cursor: 'pointer',
  },
  'with-superpack-listing-item': {
    _after: {
      position: "absolute",
      backgroundColor: 'white',
      border: '1px solid',
      borderColor: 'gray.200',
      borderRadius: 'md',
      top: 0,
      left: '10px',
      right: '10px',
      bottom: '-6px',
      zIndex: -1,
      boxShadow: "1px 2px 6px rgba(0,0,0,0.10)",
      content: '" "',
    }
  }
};
